import React, { useState } from 'react';

import { keys } from 'components/DisasterGPT/hooks/useSitrepsV2';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useApproveRequest, useRejectRequest } from 'hooks/useApprovals';
import { ITEM_TYPES } from 'constants/itemType';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';

type ReviewCardActionsProps = {
  sitrep: GetSitrepsResponse;
  isEditMode?: boolean;
  onDoneEditing?: () => void;
};

/** Approve/Reject buttons with optional comment, rendered inside a review card. */
const ReviewCardActions: React.FC<ReviewCardActionsProps> = ({
  sitrep,
  isEditMode = false,
  onDoneEditing,
}) => {
  const [reviewComment, setReviewComment] = useState('');
  const approve = useApproveRequest(keys.base);
  const reject = useRejectRequest(keys.base);
  const reviewCommentId = `review-comment-${sitrep.item_id}`;

  const isBusy = approve.isPending || reject.isPending;

  return (
    <div className="reports-card__reviews">
      <label className="visually-hidden" htmlFor={reviewCommentId}>
        Review comment (optional)
      </label>
      <Textarea
        id={reviewCommentId}
        value={reviewComment}
        onChange={(e) => setReviewComment(e.target.value)}
        placeholder="Add a comment to your review (optional)"
        maxLength={1000}
        rows={2}
      />
      <div className="reports-card__reviews__buttons">
        {onDoneEditing && (
          <Button type="button" onClick={onDoneEditing}>
            Done Editing
          </Button>
        )}
        <Button
          variant="destructive-outline"
          type="button"
          disabled={isBusy || isEditMode}
          onClick={() => {
            reject.mutate({
              itemType: ITEM_TYPES.Sitrep,
              itemId: sitrep.item_id,
              groupId: sitrep.group_guid,
              comments: reviewComment,
            });
          }}
        >
          Reject
        </Button>
        <Button
          type="button"
          disabled={isBusy || isEditMode}
          onClick={() => {
            approve.mutate({
              itemType: ITEM_TYPES.Sitrep,
              itemId: sitrep.item_id,
              groupId: sitrep.group_guid,
              comments: reviewComment,
            });
          }}
        >
          Approve
        </Button>
      </div>
    </div>
  );
};

export default ReviewCardActions;
